import {AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import * as SharedModels from '@ui-app/models';
import {UsersService} from '../../../../core/services/data-access/users.service';
import {IEmployeeSearchResult} from '@employee-models/data.models';
import {BadgeRequestCategoryEnum} from '@employee-models/data.enums';
import {EmployeeBusinessService} from '../../../../core/services/business.service';

@Component({
    selector: 'employee-approvers',
    templateUrl: './approvers.component.html',
    styleUrls: ['./approvers.component.less']
})
export class ApproversComponent implements OnInit, OnChanges, AfterViewInit {
    @Input() selectedApprovers: IEmployeeSearchResult[] = [];
    @Input() employeeFunctionId: string | number = '';
    //@Input() accessRequiredId: string | number = '';
    @Input() accessRequiredIds: number[] = [];
    @Input() employeeSiteId: string | number = '';
    @Input() isFunctionRequired = false;
    @Input() isAccessRequiredRequired = false;
    @Input() isServiceAreaRequired = false;
    @Input() maxCount = 2;
    @Input() width = '';
    @Input() title = 'Approver(s)';
    @Input() requestCategory: BadgeRequestCategoryEnum | number;
    @Input() serviceAreaId:string | number = '';
    @Input() isIRCApprover = false;
    @Input() isBusinessApprover = false;
    @Input() isTIApprover = false;
    @Input() disabled = false;
    user: any;
    @Output() approversChanged = new EventEmitter<number[]>();
    @Output() approversFullChanged = new EventEmitter<IEmployeeSearchResult[]>();
   

    get isApproversDisabled(): boolean {
            if (this.disabled) { return true; }
            this.employeeBusinessService.userProfileService.userData$.subscribe(data => this.user = data);
            if(this.user.userRoleName==="Senior Manager")
               {
                    return true ;
                }
            else{
               return false;
           };
    }

    componentInitiated = false;
    lookupPeople$;
    preselectedUser: Partial<SharedModels.CM.IUserData>;
    params: {employeeFunctionId?: string; serviceAreaId?: string; accessRequiredIds?:string};

    constructor(private usersService: UsersService,  private employeeBusinessService: EmployeeBusinessService) {

    }

    ngOnInit(): void {
        if (this.isIRCApprover) {
            this.lookupPeople$ = (searchText: string) => this.usersService
                .searchIRCApproverEmployee(searchText, this.requestCategory, this.params);
        } else if (this.isBusinessApprover) {
            this.lookupPeople$ = (searchText: string) => this.usersService
                .searchBusinessApproverEmployee(searchText, this.params);
        } else if (this.isTIApprover) {
            this.lookupPeople$ = (searchText: string) => this.usersService
                .searchTIApproverEmployee(searchText, this.params);
        } else {
            this.lookupPeople$ = (searchText: string) => this.usersService
                .searchApproverEmployee(searchText, this.requestCategory, this.params);
        }
    }

    ngAfterViewInit(): void {
        this.componentInitiated = true
    }

    ngOnChanges(changes: SimpleChanges): void {
        const employeeFunctionChanged = this.componentInitiated && changes?.employeeFunctionId?.currentValue !== changes?.employeeFunctionId?.previousValue;
        const serviceAreaChanged = this.componentInitiated && changes?.serviceAreaId?.currentValue !== changes?.serviceAreaId?.previousValue;
        const accessRequiredChanged = this.componentInitiated && changes?.accessRequiredIds?.currentValue !== changes?.accessRequiredIds?.previousValue;
        if (employeeFunctionChanged || (serviceAreaChanged && this.isServiceAreaRequired) || (accessRequiredChanged && this.isAccessRequiredRequired)) {
            this.selectedApprovers = [];
            this.setApproverValue();
        }
        this.params = {
            employeeFunctionId: this.employeeFunctionId as string,
            serviceAreaId: this.serviceAreaId as string,
           accessRequiredIds: this.accessRequiredIds.join(','),
        };
    }

    userChanged(approver: IEmployeeSearchResult): void {
        if (approver?.userId && this.selectedApprovers?.length <= this.maxCount) {
            const approverAlreadyExists = this.selectedApprovers.filter(item => item.userId === approver.userId).length;
            if (!approverAlreadyExists) {
                this.selectedApprovers = [...this.selectedApprovers, approver];
                this.setApproverValue();
            }
        }
    }

    updateApproversList(updatedList: IEmployeeSearchResult[]): void {
        this.selectedApprovers = updatedList;
        this.setApproverValue();
    }

    setApproverValue(): void {
        const approverIds: number[] = [];
        this.selectedApprovers.forEach(item => approverIds.push(item.userId));
        this.approversChanged.emit(approverIds);
        this.approversFullChanged.emit(this.selectedApprovers);
    }

}
